import PageLayout from '../components/pageLayout';
import HRList from '../components/HRList';

function WaitingListPage() {
    return (
        <PageLayout children={<HRList />} />
    );
}

export default WaitingListPage;
